module.exports = __webpack_public_path__ + "img/pr-27.072a3ab5.png";